import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  CircularProgress
} from '@mui/material';
import { AdminPanelSettings as AdminIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

function PlatformLogin() {
  const { t } = useTranslation('admin');
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/platform/auth/login', { username, password });
      if (response.data.success) {
        localStorage.setItem('platform_token', response.data.data.token);
        localStorage.setItem('platform_admin', JSON.stringify(response.data.data.admin));
        navigate('/platform/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || t('platform.login.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box component="img" src="/images/urstore-icon.jpg" alt="URStore" sx={{ width: 72, height: 72, borderRadius: 2, mb: 1 }} />
          <Typography variant="h4" gutterBottom>
            URStore SaaS
          </Typography>
          <Typography color="text.secondary">
            {t('platform.login.subtitle')}
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label={t('platform.login.username')}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ mb: 2 }}
            autoFocus
          />
          <TextField
            fullWidth
            label={t('platform.login.password')}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Button
            fullWidth
            variant="contained"
            size="large"
            type="submit"
            disabled={loading || !username || !password}
          >
            {loading ? <CircularProgress size={24} /> : t('platform.login.submit')}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}

export default PlatformLogin;
